module.exports = __webpack_public_path__ + "img/icon-switch.01a0f68c.png";